export const TEXT_TYPES = {
  ITEM: 'ITEM',
  CHOICE: 'CHOICE',
  INTERACTION_BASE: 'INTERACTION_BASE',
  DASHBOARD: 'DASHBOARD',
}

export const DEFAULT_LOCALE = {
  id: 'EN_US',
  tag: 'EN-us',
  language: 'EN',
  currency: '$',
  thousands: ','
};